import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

import backend from 'utils/backend';

// The same errors and wording as Cancel on the Loom job page.
const errorMessage = (error) => {
  return translate(`career.jobDetail.Invitations.Errors.${['INV_001', 'INV_008'].includes(error.code) ? error.code : 'Default'}`);
};

const InvitationCancelDialog = (props) => {
  const {invitationId, caregiverName, onClose, onCancelled} = props;
  const progressWrap = props.statusProgressWrap;

  const [saving, setSaving] = React.useState(false);

  const cancel = async () => {
    setSaving(true);
    await progressWrap(async () => {
      try {
        await backend.loom.caregiver.cancelInvitation(invitationId);
      } finally {
        // A failed cancel can still mean the invitation closed, so the list reloads either way.
        onCancelled();
      }
    }, {
      onErrorMessage: errorMessage,
      debugString: 'LOOM_CAREGIVER_INVITATION_CANCEL',
    });
    setSaving(false);
  };

  return (
    <Dialog onClose={onClose}>
      <DialogTitle onClose={onClose}>
        <Translate expression='career.jobDetail.Invitations.CancelTitle' />
      </DialogTitle>
      <DialogContent>
        <Typography variant='body2' pt={1}>
          <Translate
            expression='career.jobDetail.Invitations.CancelConfirm'
            substitute={{name: caregiverName || ''}}
          />
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='career.jobDetail.Invitations.Keep' />
        </Button>
        <Button color='error' disabled={saving} onClick={cancel}>
          <Translate expression='career.jobDetail.Invitations.Cancel' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

InvitationCancelDialog.propTypes = {
  invitationId: PropTypes.string.isRequired,
  caregiverName: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onCancelled: PropTypes.func.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(InvitationCancelDialog));
